import type { AuthServicePorts } from "../../model";

import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  email,
  phoneNumber,
  userName,
  firstName,
  lastName,
  roles,
  ...rest
}: Common.OutSchema): AuthServicePorts.ProviderIos.Common.Out {
  return {
    ...rest,
    email: email ?? EMPTY,
    phone: phoneNumber ?? EMPTY,
    username: userName ?? EMPTY,
    firstName: firstName ?? EMPTY,
    lastName: lastName ?? EMPTY,
    roles: roles.map(({ id, name, description }) => ({
      id,
      name: name ?? EMPTY,
      description: description ?? EMPTY,
    })),
  };
}

export { mapDtoToEntity };
